import { Iframe } from "./Iframe";

export class Youtube extends Iframe {
    protected initialize(data: any) {
        data.set("html", "<iframe class=\"youtube\" src=\"https://www.youtube.com/embed/" + data.get("id") + "\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>");
        super.initialize(data);
    }
}
